<template>
  <main>
    <div class="p10">
      <h2 class="center">利用規約</h2>
      <p>この利用規約(以下，「本規約」といいます。)は、3PLATZ株式会社(以下，「当社」といいます。)が、提供するサービス『CHOY-SAN』(以下，「本サービス」といいます。)の利用条件を定めるものです。登録ユーザーの皆さま(以下，「ユーザー」といいます。)には，本規約に従って，本サービスをご利用いただきます。 </p>

      <h3>第1条（適用）</h3>
      <p>本規約は，ユーザーと当社との間の本サービスの利用に関わる一切の関係に適用されるものとします。 </p>

      <h3>第2条（利用規約への同意）</h3>
      <p>１ ユーザーは、本規約の定めに従って本サービスを利用しなければなりません。</p>
      <p>２ ユーザーは、本サービスを利用することにより、本規約に同意することになります。</p>
      <p>３ 本サービスにおいて個別利用条件がある場合、ユーザーは、本規約のほか個別利用条件にも従って本サービスを利用しなければなりません。</p>

      <h3>第3条（利用規約の変更）</h3>
      <p>１ 当社は以下の場合に、利用規約を変更することができます。</p>
      <p>(1)利用規約の変更が、ユーザーの一般の利益に適合するとき。</p>
      <p>(2)利用規約の変更が、契約をした目的に反せず、かつ、変更の必要性、変更後の内容の相当性、変更の内容その他の変更に係る事情に照らして合理的なものであるとき。</p>
      <p>２ 当社は前項による利用規約の変更にあたり、変更後の利用規約の効力発生日の１か月前までに、利用規約を変更する旨及び変更後の利用規約の内容とその効力発生日を当社ウェブサイト（URL：https://c.choy-san.jp/）に掲示し、またはユーザーに電子メールで通知します。</p>
      <p>３ 変更後の利用規約の効力発生日以降にユーザーが本サービスを利用したときは、ユーザーは、利用規約の変更に同意したものとみなします。</p>
      
      <h3>第4条（利用登録）</h3>
      <p>１ 登録希望者が当社の定める方法によって利用登録を申請し，当社がこれを承認することによって，利用登録が完了するものとします。</p>
      <p>２ 当社は，利用登録の申請者に以下の事由があると判断した場合，利用登録の申請を承認しないことがあり，その理由については一切の開示義務を負わないものとします。</p>
      <p>(1)利用登録の申請に際して虚偽の事項を届け出た場合 </p>
      <p>(2)本規約に違反したことがある者からの申請である場合 </p>
      <p>(3)未成年者，成年被後見人，被保佐人または被補助人のいずれかであり，法定代理人，後見人，保佐人または補助人の同意等を得ていなかった場合 </p>
      <p>(4)反社会的勢力等(暴力団，暴力団員，右翼団体，反社会的勢力，その他これに準ずる者を意味します。)である，または資金提供その他を通じて反社会的勢力等の維持，運営もしくは経営に協力もしくは関与する等反社会的勢力との何らかの交流もしくは関与を行っていると当社が判断した場合 </p>
      <p>(5)その他，当社が利用登録を相当でないと判断した場合 </p>

      <h3>第5条（ユーザーIDおよびパスワードの管理）</h3>
      <p>１ ユーザーは，自己の責任において，本サービスのユーザーIDおよびパスワードを管理するものとします。</p>
      <p>２ ユーザーは，いかなる場合にも，ユーザーIDおよびパスワードを第三者に譲渡または貸与することはできません。当社は，ユーザーIDとパスワードの組み合わせが登録情報と一致してログインされた場合には，そのユーザーIDを登録しているユーザー自身による利用とみなします。 </p>

      <h3>第6条（プライバシーへの配慮と個人情報の管理）</h3>
      <p>１ 当社は、ユーザーのプライバシーを尊重します。</p>
      <p>２ 当社は、ユーザーのプライバシー情報と個人情報について、個人情報保護方針（https://3platz.jp/#management-philosophy）に従って、適切に取り扱います。</p>
      <p>３ 当社は、以下の各号記載の本サービスをご利用いただくに当たりお客様からご提供いただいた情報及びサービス利用により取得した情報を保有します。</p>
      <p>(1) 氏名、電話番号、メールアドレス等のアカウント登録情報</p>
      <p>(2) 生年月日、国籍を含む出身地、アイコン等のプロフィール情報</p>
      <p>(3) クッキー（cookie）、アクセスログ、サービス利用状況に関する情報、お支払情報、位置情報、機器情報、第三者が運営するサービスに関する情報等の本サービス及び関連サービスの利用情報</p>
      <p>４ 当社は、取得し保有する情報を以下の目的で利用します。</p>
      <p>(1) 当社サービスの提供及び質の向上のため</p>
      <p>(2) 当社サービスのセキュリティ及び不正利用防止のため</p>
      <p>(3) 当社サービス及び提携先企業のサービスに関する情報等を告知するため</p>
      <p>５ 当社は、法令で定められる場合を除いて、利用者情報をお客様の同意なく第三者に提供しません。ただし、当社は、利用目的の達成に必要な範囲内において、提携先企業にお客様の情報を提供することができます。お客様は、これに同意の上で当社サービスを利用することとし、利用した場合には、同意したこととなります。当社は、情報を提供した事業者を速やかに当社ウエブサイト（URL：https://c.choy-san.jp/）に掲示し、またはユーザーに電子メールで通知します。</p>
      <p>６ 当社は、利用目的の達成に必要な範囲内においてお客様から取得した情報の全部又は一部を業務委託先に委託することがあります。</p>
      <p>７ 当社は、利用目的の達成の範囲で、利用情報を当社関連会社にと共同利用します。当社は、お客様の情報を共同利用する関連会社を当社ウエブサイト（URL：https://c.choy-san.jp/）に掲示し、またはユーザーに電子メールで通知します。</p>

      <h3>第7条（禁止事項）</h3>
      <p>１ ユーザーは，本サービスの利用にあたり，以下の行為をしてはなりません。</p>
      <p>(1)法令または公序良俗に違反する行為 </p>
      <p>(2)犯罪行為に関連する行為 </p>
      <p>(3)当社のサーバーまたはネットワークの機能を破壊したり，妨害したりする行為 </p>
      <p>(4)当社のサービスの運営を妨害するおそれのある行為 </p>
      <p>(5)他のユーザーに関する個人情報等を収集または蓄積する行為 </p>
      <p>(6)他のユーザーに成りすます行為 </p>
      <p>(7)当社のサービスに関連して，反社会的勢力に対して直接または間接に利益を供与する行為 </p>
      <p>(8)当社，本サービスの他の利用者または第三者の知的財産権，肖像権，プライバシー，名誉その他の権利または利益を侵害する行為 </p>
      <p>(9)過度に暴力的な表現，露骨な性的表現，人種，国籍，信条，性別，社会的身分，門地等による差別につながる表現，自殺，自傷行為，薬物乱用を誘引または助長する表現，その他反社会的な内容を含み他人に不快感を与える表現を，投稿または送信する行為 </p>
      <p>(10)営業，宣伝，広告，勧誘，その他営利を目的とする行為(当社の認めたものを除きます。)，性行為やわいせつな行為を目的とする行為，面識のない異性との出会いや交際を目的とする行為，他のお客様に対する嫌がらせや誹謗中傷を目的とする行為，その他本サービスが予定している利用目的と異なる目的で本サービスを利用する行為 </p>
      <p>(11)宗教活動または宗教団体への勧誘行為 </p>
      <p>(12)その他，当社が不適切と判断する行為 </p>
      <p>２ ユーザーが前項各号に該当する行為を行ったことによって、損害を被ったと主張する他のユーザーから、当社に対し、ユーザーに関して保有する情報開示請求があった場合、当社は、当該情報を開示できるものとし、ユーザーはこれを受忍するものとします。</p>
      <p>３ 当社は、前項に基づいてユーザーの情報を開示したことにより生じたユーザーの損害について、一切の責任を負わないものとします。</p>

      <h3>第8条（本サービスの提供の停止等）</h3>
      <p>１ 当社は，以下のいずれかの事由があると判断した場合，ユーザーに事前に通知することなく本サービスの全部または一部の提供を停止または中断することができるものとします。</p>
      <p>(1)本サービスにかかるコンピュータシステムの保守点検または更新を行う場合 </p>
      <p>(2)地震，落雷，火災，停電または天災などの不可抗力により，本サービスの提供が困難となった場合 </p>
      <p>(3)コンピュータまたは通信回線等が事故により停止した場合 </p>
      <p>(4)その他，当社が本サービスの提供が困難と判断した場合 </p>
      <p>２ 当社は，本サービスの提供の停止または中断により，ユーザーまたは第三者が被ったいかなる不利益または損害について，理由を問わず一切の責任を負わないものとします。 </p>

      <h3>第9条（著作権その他の知的財産権）</h3>
      <p>１ ユーザーは，自ら著作権等の必要な知的財産権を有するか，または必要な権利者の許諾を得た文章，画像や映像等の情報のみ，本サービスを利用し，投稿または編集することができるものとします。</p>
      <p>２ ユーザーが本サービスを利用して投稿または編集した文章，画像，映像等の著作権については，当該ユーザーその他既存の権利者に留保されるものとします。ただし，当社は，本サービスを利用して投稿または編集された文章，画像，映像等を利用できるものとし，ユーザーは，この利用に関して，著作者人格権を行使しないものとします。</p>
      <p>３ 前項本文の定めるものを除き，本サービスおよび本サービスに関連する一切の情報についての著作権およびその他知的財産権はすべて当社または当社にその利用を許諾した権利者に帰属し，ユーザーは、非独占的な本サービスの利用ができるのみで、無断で複製，譲渡，貸与，翻訳，改変，転載，公衆送信(送信可能化を含みます。)，伝送，配布，出版，営業使用等をしてはならないものとします。</p>
      
      <h3>第10条（利用制限および登録抹消）</h3>
      <p>１ 当社は，以下の場合には，事前の通知なく，投稿データを削除し，ユーザーに対して本サービスの全部もしくは一部の利用を制限しまたはユーザーとしての登録を抹消することができるものとします。 </p>
      <p>(1)本規約のいずれかの条項に違反した場合 </p>
      <p>(2)登録事項に虚偽の事実があることが判明した場合 </p>
      <p>(3)破産，民事再生，会社更生または特別清算の手続開始決定等の申立てがなされたとき </p>
      <p>(4)1年間以上本サービスの利用がない場合 </p>
      <p>(5)当社からの問い合わせその他の回答を求める連絡に対して30日間以上応答がない場合 </p>
      <p>(6)第4条第2項各号に該当する場合 </p>
      <p>(7)その他，当社が本サービスの利用を適当でないと判断した場合 </p>
      <p>２ 前項各号のいずれかに該当した場合，ユーザーは，当然に当社に対する一切の債務について期限の利益を失い，その時点において負担する一切の債務を直ちに一括して弁済しなければなりません。</p>
      <p>３ 当社は，本条に基づき当社が行った行為によりユーザーに生じた損害について，一切の責任を負いません。 </p>

      <h3>第11条（保証の否認および免責事項）</h3>
      <p>１ 当社は，本サービスに事実上または法律上の瑕疵(安全性，信頼性，正確性，完全性，有効性，特定の目的への適合性，セキュリティなどに関する欠陥，エラーやバグ，権利侵害などを含みます。)がないことを明示的にも黙示的にも保証しておりません。</p>
      <p>２ 当社は，本サービスに起因してユーザーに生じたあらゆる損害について一切の責任を負いません。ただし，本サービスに関する当社とユーザーとの間の契約(本規約を含みます。)が消費者契約法に定める消費者契約となる場合，この免責規定は適用されません。</p>
      <p>３ 前項ただし書に定める場合であっても，当社は，当社の過失(重過失を除きます。)による債務不履行または不法行為によりユーザーに生じた損害のうち特別な事情から生じた損害(当社またはユーザーが損害発生につき予見し，または予見し得た場合を含みます。)について一切の責任を負いません。また，当社の過失(重過失を除きます。)による債務不履行または不法行為によりユーザーに生じた損害の賠償は，ユーザーから当該損害が発生した月に受領した利用料の額を上限とします。</p>
      <p>４ 当社は，本サービスに関して，ユーザーと他のユーザーまたは第三者との間において生じた取引，連絡または紛争等について一切責任を負いません。</p>
      
      <h3>第12条（サービス内容の変更等）</h3>
      <p>当社は，ユーザーに通知することなく，本サービスの内容を変更しまたは本サービスの提供を中止することができるものとし，これによってユーザーに生じた損害について一切の責任を負いません。</p>
      
      <h3>第13条（通知または連絡）</h3>
      <p>ユーザーと当社との間の通知または連絡は，当社の定める方法によって行うものとします。 </p>

      <h3>第14条（権利義務の譲渡の禁止）</h3>
      <p>ユーザーは，当社の書面による事前の承諾なく，利用契約上の地位または本規約に基づく権利もしくは義務を第三者に譲渡し，または担保に供することはできません。</p>
      
      <h3>第15条（準拠法・裁判管轄）</h3>
      <p>本規約の解釈にあたっては，日本法を準拠法とします。</p>
      <p>本サービスに関して紛争が生じた場合には，当社の本店所在地を管轄する裁判所を専属的合意管轄とします。 </p>
    </div>
  </main>
</template>

<script>
export default {
  name: 'Terms'
}
</script>

<style scoped>
.p10 {
  margin: 20px;
}
h2 {
  margin: 40px 0px;
}
h3 {
  margin-top: 30px;
  font-size: 14px;
  font-weight: bold;
}
</style>